import React, { useEffect, useState } from 'react';
import styled, { keyframes } from 'styled-components';

const sizes = {
  mobileM: '375px',
  mobileL: '425px',
  tablet: '768px',
  desktop: '1800px',
};

export const device = {
  tablet: `(max-width: ${sizes.tablet})`,
  desktop: `(min-width: ${sizes.desktop})`,
};
const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 60px;
  align-items: center;
  @media only screen and ${device.tablet} {
    margin-top: unset;
  }
`;

const Heading = styled.div`
  font-family: Inter;
  font-weight: 600;
  font-size: 64px;

  max-width: 1140px;
  text-align: center;
  color: #267b62;
  @media only screen and ${device.tablet} {
    max-width: 345px;
    font-size: 36px;
  }
`;

const Highlight = styled.span`
  font-family: Inter;
  font-weight: 600;
  font-size: 64px;

  text-align: center;
  color: #063257;
  @media only screen and ${device.tablet} {
    font-size: 36px;
  }
`;
const SubTitleText = styled.div`
  font-family: Inter;
  font-weight: 400;
  font-size: 18px;
  line-height: 24px;
  text-align: center;
  color: #12121299;
  max-width: 574px;
  margin-top: 30px;
  @media only screen and ${device.tablet} {
    max-width: 345px;
    font-size: 14px;
  }
`;
const TagContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  justify-content: center;
  padding: 20px;
  max-width: 574px;
  @media only screen and ${device.tablet} {
    max-width: 345px;
  }
`;

const Tag = styled.div`
  border-radius: 20px;

  box-shadow: 4px 4px 4px 0px #07234b40;

  backdrop-filter: blur(11.300000190734863px);

  height: 33px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(
    92.31deg,
    rgba(161, 216, 35, 0.3) 0.45%,
    rgba(151, 228, 132, 0.3) 99.55%
  );
  font-family: Inter;
  font-weight: 400;
  font-size: 14px;

  text-align: center;
  color: #121212;
  padding-left: 16px;
  padding-right: 16px;
`;
const GetStartedButton = styled.button`
  margin-top: 60px;
  width: 271px;
  height: 69px;
  gap: 10px;
  border: none;
  border-radius: 10px;
  padding: 20px;
  background: linear-gradient(93.98deg, #0c3f89 0.31%, #4aa373 99.69%);
  font-family: Inter;
  font-weight: 600;
  font-size: 24px;

  text-align: center;
  color: #fafafa;
  transition: background 0.3s ease;

  &:hover {
    cursor: pointer;
    background: linear-gradient(93.98deg, #092f6b 0.31%, #3a865e 99.69%);
  }

  @media only screen and ${device.tablet} {
    margin-top: 30px;
  }
`;

const ReadLink = styled.button`
  width: 249px;
  height: 17px;
  font-family: Inter;
  border: none;
  background: none;
  font-weight: 300;
  font-size: 14px;

  text-align: center;
  text-decoration: underline;
  text-decoration-style: solid;
  text-decoration-offset: 0%;
  text-decoration-thickness: 0%;
  text-decoration-skip-ink: auto;
  color: #014034;
  margin-top: 10px;
  &:hover {
    cursor: pointer;
  }
`;
const items = [
  'Market Research',
  'Brand Health',
  'Competitive Intelligence',
  'Engagement Analysis',
  'Emotional Analysis',
  'Sentiment Analysis',
];
const cursorBlink = keyframes`
  0% { opacity: 1; }
  50% { opacity: 0; }
  100% { opacity: 1; }
`;

const TypewriterText = styled.span`
  font-weight: 700;
  color: #063257;
`;
const Cursor = styled.span`
  border-right: 2px solid #0a2a4a;
  padding-right: 2px;
  animation: ${cursorBlink} 0.7s step-end infinite;
`;
// const WordSwitcher = styled.div`
//   position: relative;
//   height: 64px;
//   overflow: hidden;
//   display: inline-block;

//   @media only screen and ${device.tablet} {
//     height: 36px;
//   }
// `;

// const WordList = styled.div`
//   display: flex;
//   flex-direction: column;
//   transform: translateY(${(props) => `-${props.index * 33.3}%`});
//   transition: transform 0.6s ease-in-out;
// `;

// const Word = styled.div`
//   height: 64px;
//   font-family: Inter;
//   font-weight: 600;
//   font-size: 64px;
//
//   color: rgba(6, 50, 87, 1);
//   display: flex;
//   justify-content: center;
//   align-items: center;

//   @media only screen and ${device.tablet} {
//     height: 36px;
//     font-size: 36px;
//   }
// `;

const HowMillionsofBrands = (props) => {
  const words = ['decode', 'track', 'analyze'];

  const [text, setText] = useState('');
  const [isDeleting, setIsDeleting] = useState(false);
  const [wordIndex, setWordIndex] = useState(0);

  useEffect(() => {
    let timer;
    const fullWord = words[wordIndex];
    const typingSpeed = 120;
    const deletingSpeed = 80;
    const pauseTime = 1000;

    if (!isDeleting && text.length < fullWord.length) {
      // Typing
      timer = setTimeout(() => {
        setText(fullWord.slice(0, text.length + 1));
      }, typingSpeed);
    } else if (isDeleting && text.length > 0) {
      // Deleting
      timer = setTimeout(() => {
        setText(fullWord.slice(0, text.length - 1));
      }, deletingSpeed);
    } else {
      // Wait and then switch between typing/deleting or next word
      timer = setTimeout(() => {
        if (isDeleting) {
          setIsDeleting(false);
          setWordIndex((prevIndex) => (prevIndex + 1) % words.length);
        } else {
          setIsDeleting(true);
        }
      }, pauseTime);
    }

    return () => clearTimeout(timer);
  }, [text, isDeleting, wordIndex]);
  // const [wordIndex, setWordIndex] = useState(0);

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     setWordIndex((prev) => (prev + 1) % words.length);
  //   }, 2000); // Change every 2 seconds

  //   return () => clearInterval(interval);
  // }, []);

  return (
    <Wrapper>
      <Heading>
        How millions of brands{' '}
        <TypewriterText>
          {text}
          <Cursor />
          {'  '}
        </TypewriterText>
      </Heading>
      <Heading style={{ marginTop: 'unset' }}>
        {/* <WordSwitcher>
          <WordList index={wordIndex}>
            {words.map((word, i) => (
              <Word key={i}>{word}</Word>
            ))}
          </WordList>
        </WordSwitcher> */}
        emotion with AI-powered insights.
      </Heading>
      <SubTitleText>
        Unify all your consumer listening, social listening, and publishing
        across multiple digital touchpoints analyzed through.
      </SubTitleText>
      <TagContainer>
        {items?.map((item, index) => (
          <Tag key={index}>{item}</Tag>
        ))}
      </TagContainer>
      <GetStartedButton onClick={() => props?.setPopupOpen(true)}>
        Get Started for Free
      </GetStartedButton>
      {/* <ReadLink>Read Why</ReadLink> */}
    </Wrapper>
  );
};

export default HowMillionsofBrands;
